export const TAG_COLOR_OPTIONS = [
  { label: 'Verde', value: '15ce9a', kind: 'success' },
  { label: 'Vermelho', value: 'e93f66', kind: 'danger' },
  { label: 'Amarelo', value: 'f4d03f', kind: 'warning' },
  { label: 'Azul', value: '318be3', kind: 'info' },
  { label: 'Cinza', value: '87929c', kind: 'default' },
  { label: 'Roxo', value: '8b5cf6', kind: 'purple' },
  { label: 'Laranja', value: 'f97316', kind: 'orange' },
  { label: 'Verde-água', value: '14b8a6', kind: 'teal' },
  { label: 'Rosa', value: 'ec4899', kind: 'pink' },
  { label: 'Índigo', value: '6366f1', kind: 'indigo' },
  { label: 'Lima', value: '65a30d', kind: 'lime' },
  { label: 'Ciano', value: '0891b2', kind: 'cyan' },
  { label: 'Vinho', value: 'e11d48', kind: 'rose' },
  { label: 'Âmbar', value: 'd97706', kind: 'amber' },
  { label: 'Ardósia', value: '475569', kind: 'slate' }
]

export const DEFAULT_TAG_COLOR = '87929c'

const DARK_TEXT = '#051B30'
const LIGHT_TEXT = '#fff'

export function tagTextColor(hex) {
  const color = (hex || DEFAULT_TAG_COLOR).replace('#', '')
  const r = parseInt(color.substr(0, 2), 16)
  const g = parseInt(color.substr(2, 2), 16)
  const b = parseInt(color.substr(4, 2), 16)
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255

  return luminance > 0.6 ? DARK_TEXT : LIGHT_TEXT
}
